import scala from "refractor/scala";
export default scala;